import { Button, Modal, Typography } from "antd";
import React from "react";

const { Title, Text } = Typography;

const StopModal = ({ modalVisible, setModalVisible, handleFinish, setFinishMessage }) => {
    return (
        <Modal
            open={modalVisible}
            closable={false}
            width={600}
            footer={null}
            centered
            styles={{
                mask: {
                    backdropFilter: 'blur(8px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)'
                }
            }}
        >
            <div style={{ textAlign: 'center' }}>
                <Title level={4}>Testni tugatasizmi?</Title>
                <Text>Hali vaqtingiz bor, davom ettirishingiz mumkin!</Text>

                <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 24 }}>
                    <Button
                        danger
                        size="large"
                        onClick={() => {
                            setFinishMessage("Natija telegram orqali yuboriladi!")
                            setModalVisible(false);
                            handleFinish();
                        }}
                    >
                        Tugatish
                    </Button>

                    <Button
                        type="primary"
                        size="large"
                        onClick={() => setModalVisible(false)}
                    >
                        Davom ettirish
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default StopModal;
